module.exports = __webpack_public_path__ + "static/evga-ftw3-87aa1469574d55bf5ce8f20645445cd1.jpg";